import { render, staticRenderFns } from "./position.vue?vue&type=template&id=13a42990&scoped=true&"
import script from "./position.vue?vue&type=script&lang=js&"
export * from "./position.vue?vue&type=script&lang=js&"
import style0 from "./position.vue?vue&type=style&index=0&id=13a42990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a42990",
  null
  
)

export default component.exports